<app-breadcrumbs [breadcrumbs]="breadcrumbs" [showHome]="false" class="d-block mb-4"></app-breadcrumbs>

<h2>{{ prefix + '-titel' | fromDictionary }}</h2>

@if (orders$(); as orders) {
  <ul class="order-list">
    <li class="order-list__header">
      <span>{{ 'label-order-nummer' | fromDictionary }}</span>
      <span>{{ 'label-product' | fromDictionary }}</span>
      <span class="order-list--hide-mobile">{{ 'label-betaalstatus' | fromDictionary }}</span>
      <span class="order-list--hide-mobile">{{ 'label-fulfillment-status' | fromDictionary }}</span>
      <span>{{ 'label-totaalprijs-kort' | fromDictionary }}</span>
    </li>
    @for (order of orders; track order.orderNumber) {
      <li class="order-list__item" (click)="navigate(order.orderNumber.toString())">
        <app-order-list-item [order]="order"></app-order-list-item>
      </li>
    }
  </ul>
}
@if (!orders$()?.length) {
  <div class="mt-1 p-3 bg-gray-100 type-body-sm">{{ 'order-overzicht-leeg' | fromDictionary }}</div>
}

@if (pages$()?.hasNextPage) {
  <div class="text-center mt-3" (fstrInViewport)="loadMore()" [once]="false">
    <button class="button button-outline button--secondary" (click)="loadMore()">{{ prefix + '-toon-meer' | fromDictionary }}</button>
  </div>
}
